import * as singleSpa from "single-spa"
import { catchSyncStacktrace } from "auto-trace"
import { calculatePublicPath } from "canopy-sofe-extensions"
import "sofe"
import * as isActive from "./child-app-active.functions.js"

import bootstrapSpa from "./bootstrap/spa-bootstrapper.js"

export { showAppInstall } from "./app-install/app-install.helper"

__webpack_public_path__ = calculatePublicPath("mobile-root-config")

bootstrapSpa()
  .then(() => {})
  .catch(err => {
    catchSyncStacktrace(err)
  })

singleSpa.registerApplication(
  "login-ui",
  () => SystemJS.import("login-ui!sofe").then(mod => mod.mobileLifecycles),
  isActive.loginUI,
)

singleSpa.registerApplication(
  "billing-ui",
  () => SystemJS.import("billing-ui!sofe").then(mod => mod.mobilePaymentsLifecycles),
  isActive.mobilePaymentsUI,
)

singleSpa.registerApplication("client-portal", () => SystemJS.import("client-portal!sofe"), isActive.clientUI)

//TODO Remove
// singleSpa.registerApplication(
//   "mobile-practioner-ui",
//   () => import(/* webpackChunkName: 'practitioner-app'*/ "./practitioner/practitioner.app.js"),
//   isActive.practitionerUI,
// )

singleSpa.registerApplication(
  "client-review",
  () => SystemJS.import("tax-prep-ui!sofe").then(mod => mod.clientReviewLifecycles),
  isActive.clientReviewUI,
)

singleSpa.start()
